async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    credentials: "same-origin",
    ...init,
    headers: { Accept: "application/json", ...(init?.headers ?? {}) },
  });
  if (!res.ok) {
    let body: unknown = null;
    try {
      body = await res.json();
    } catch {
      /* ignore */
    }
    const err = new Error(`API ${res.status} on ${path}: ${JSON.stringify(body)}`);
    (err as Error & { status?: number }).status = res.status;
    throw err;
  }
  if (res.status === 204) return undefined as T;
  const ct = res.headers.get("Content-Type") ?? "";
  if (ct.includes("application/json")) return (await res.json()) as T;
  return (await res.text()) as unknown as T;
}

export const api = {
  get: <T,>(path: string) => request<T>(path),
  post: <T,>(path: string, body: unknown) =>
    request<T>(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }),
  patch: <T,>(path: string, body: unknown) =>
    request<T>(path, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }),
  delete: <T,>(path: string) => request<T>(path, { method: "DELETE" }),
};

export interface GlossaryEntry {
  id: number;
  term: string;
  never_translate: boolean;
  fixed_translations: Record<string, string> | null;
  notes: string | null;
  updated_by: string | null;
  updated_at: string;
}

export interface AuditEntry {
  id: number;
  user_email: string;
  user_role: string;
  action: string;
  target_type: string | null;
  target_id: string | null;
  payload: unknown;
  ts: string;
}

export interface RenderEntry {
  id: number;
  sku: string;
  lang: string;
  attempts: number;
  final_font_scale: number;
  overflowed: number;
  duration_ms: number;
  requested_by: string | null;
  ts: string;
}
